import styled from "styled-components";
import {motion} from "framer-motion";
import React, {useEffect, useState} from "react";
// @ts-ignore
import game_hint_video from './../../assets/game_hint.mp4';
// @ts-ignore
import bomb_hint_video from './../../assets/bomb_hint_video.mp4';
import {useAppContext} from "../../provider/AppProvider";
import {dataStorage} from "../../utils/StorageService";

const overlayVariants = {
    open: {
        opacity: 1,
        transition: {
            duration: 0.1,
            ease: "easeOut",
        },
    },
    closed: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: "easeOut",
        },
    }
}

const modalVariants = {
    open: {
        scale: [0.5, 1.15, 1.0],
        transition: {
            duration: 0.1,
            type: 'spring',
            damping: 25,
            stiffness: 500,
        }
    },
    closed: {
        scale: [1, 0],
    }
}

const Root = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 443213123;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Overlay = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    background: rgba(65, 67, 73, 0.9);
    z-index: -1;
`

const ModalRoot = styled(motion.div)`
    width: 300px;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 30px;
    overflow: hidden;
    
    @media (min-width: 768px) {
        width: 450px;
    }

    @media (min-width: 1024px) {
        width: 600px;
    }
    
    @media (hover: hover) and (pointer: fine) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 90%;
    }
`;

const BackgroundVideo = styled.video`
    width: 100%;
    object-fit: fill;
    height: 350px;

    @media (min-width: 768px) {
        height: 500px;
    }

    @media (min-width: 1024px) {
        height: 650px;
    }
`

const TextContainer = styled.div`
    text-align: center;
    font-weight: 900;
    color: white;
    font-size: 12px;
    max-width: 80%;
    margin: 8px auto 8px auto;

    @media (min-width: 768px) {
        font-size: 18px;
    }

    @media (min-width: 1024px) {
        font-size: 22px;
    }

    @media (hover: hover) and (pointer: fine) {
        display: flex;
        padding: 12px;
        justify-content: center;
        align-items: center;
    }
`;

const Text = styled.div``;

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export const HintModal = ({isOpen, onClose}: Props) => {
    const {translate} = useAppContext();
    const [isVisible, setVisible] = useState<null | boolean>(null);

    useEffect(() => {
        setVisible(isOpen);
    }, [isOpen]);

    useEffect(() => {
        if (isVisible === false) {
            setTimeout(() => {
                onClose();
            }, 600)
        }
    }, [isVisible])

    const handleCloseHint = () => {
        setVisible(false);
    }

    return (
        <Root onClick={handleCloseHint}>
            <Overlay
                initial="closed"
                animate={isVisible ? "open" : "closed"}
                variants={overlayVariants}
            />
            <ModalRoot variants={modalVariants} animate={isVisible ? "open" : "closed"}>
                <BackgroundVideo autoPlay loop muted playsInline preload="auto">
                    <source src={dataStorage.isBombMode ? bomb_hint_video : game_hint_video} type="video/mp4" />
                    Your browser does not support the video tag.
                </BackgroundVideo>
                <TextContainer>
                    <Text>{dataStorage.isBombMode ? translate.hint_bomb.toUpperCase() : translate.hint.toUpperCase()}</Text>
                </TextContainer>
            </ModalRoot>
        </Root>
    )
}
